import React from 'react';
import { createStyleManager, StyleManager } from 'jss-theme-reactor';
import { createMuiTheme, ITheme } from '@/styles/theme';
import jssPreset from '@/styles/utils/preset';
// FIX: Use `require` to solve the module resolution issue with the old @types/jss package.
const { create } = require('jss');

export interface IStyleManagerContext {
  styleManager: StyleManager;
  theme: ITheme;
}

const defaultTheme = createMuiTheme();
const defaultStyleManager = createStyleManager({
  theme: defaultTheme,
  jss: create(jssPreset({})),
});

// Create the context with a default value
export const StyleManagerContext = React.createContext<IStyleManagerContext>({
  theme: defaultTheme,
  styleManager: defaultStyleManager,
});